import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import Backfeed from './icons/Backfeed';
import Battery from './icons/Battery';
import Data from './icons/Data';
import Drop from './icons/Drop';
import Protection from './icons/Protection';
import Retradant from './icons/Retradant';
import styles from './index.module.scss';

const Compact: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Compact');

    const icons = [
        {
            icon: <Retradant />,
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            icon: <Protection />,
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            icon: <Backfeed />,
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            icon: <Drop />,
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
        {
            icon: <Battery />,
            title: t('item5_title'),
            desc: t('item5_desc'),
        },
        {
            icon: <Data />,
            title: t('item6_title'),
            desc: t('item6_desc'),
        },
    ];

    const card1ImgObj = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1754042092440/18.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1754042092280/18_M.jpg',
    };

    return (
        <div
            className={`${styles.Compact} GtmModuleData-section`}
            id={'stream-ultra-x-Compact'}
            data-section-id={'stream-ultra-x-Compact'}
            data-section-title={t('sub_title')}
        >
            <EcoSpace hPc="140px" hPad="100px" hH5="100px" />
            <EcoSectionCommon className="bottom-box" title={t('sub_title')} desc={t('sub_desc')} />
            <div className="content-box eco-content">
                <div className="section-img">
                    <EcoImg pc={card1ImgObj.pc} pad={card1ImgObj.pc} h5={card1ImgObj.h5} isOpenLazy></EcoImg>
                </div>
                <div className="icons-wrapper">
                    {icons.map((icon, index) => {
                        return (
                            <div className="icon-wrapper" key={icon.title + index}>
                                {icon.icon}
                                <div className="title">{icon.title}</div>
                                <div className="desc">{icon.desc}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Compact;
